var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.list_gridOptions)?_c('vxe-grid',_vm._b({ref:"groupkpiTable",on:{"toolbar-button-click":_vm.list_toolbarButtonClickEvent}},'vxe-grid',_vm.list_gridOptions,false)):_vm._e(),_c('add-index',{ref:"addspukpiIndex",attrs:{"nodeid":_vm.nodeid},on:{"modalhide":_vm.addHide}}),_c('importTable',{ref:_vm.importRef})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }